<template lang="pug">
v-container.py-10
  .text-h4.text-center.mb-8
    .ubuntu Catálogos - {{ content.title }}
  v-sheet.mx-auto(max-width="1000px")
    v-list-item.page-catalog-list-item.mb-3.rounded(
      v-for="({ title, img, file }, i) in content.catalogs",
      :key="i"
    )
      v-list-item-icon(v-if="!xs")
        img.page-catalogs-img(:src="files + img", :alt="title")
      v-list-item-content
        .ubuntu.font-weight-bold {{ title }}
      v-list-item-action
        v-btn.text-none(
          :class="!sm && 'rounded-pill'",
          :href="files + file",
          target="_blank",
          color="primary",
          depressed,
          :small="sm",
          :fab="sm"
        )
          v-icon(:left="!sm", :small="sm") fas fa-download
          span(v-if="!sm") Download
</template>

<script>
import groupBy from "lodash.groupby";

const _config = {
  mod: "catalogs",
  path: "/catalogos",
};

export default {
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    content() {
      const groups = groupBy(
        this.$rest(_config.mod).list.map((item) => {
          item.brandId = item.brand.id;
          return item;
        }),
        "brandId"
      );

      let brands = Object.entries(groups).map(([, items]) => {
        return {
          id: items[0].brand.id,
          title: items[0].brand.title,
          img: items[0].img,
        };
      });

      const brand = brands.find(({ id }) => id == this.itemId);

      if (!brand) return {};

      brand.catalogs = groups[brand.id];

      return brand;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
};
</script>

<style>
.page-catalog-list-item {
  border: 1px solid #ddd;
}
.page-catalogs-img {
  aspect-ratio: 380 / 365;
  object-fit: cover;
  max-width: 80px;
}
</style>
